
import {
	DBxEvent
} from "cartovista";
import { ZoomLayeringServer, createLayer, createThemeSetElement, _loadLayersData, _loadEsriLayersData, _loadCartovistaLayersData, joinDataTable } from "@meq/cartovista-extend";

export function loadData() {
        return Promise.all([_loadLayersData(_.filter(C.LAYERS, {LOADING_MODE : "INITIAL"})), _loadEsriLayersData(_.filter(C.LAYERS, {LOADING_MODE : "ESRI"})), _loadCartovistaLayersData(_.filter(C.LAYERS, {LOADING_MODE : "CARTOVISTA"}))]).then(function(responses) {
                return responses;
            }).then(function(response) {
                var ThematiqueProv_Reseau = require("configs/layers/ThematiqueProv_Reseau"),
				         ThematiqueProv_EHDAA = require("configs/layers/ThematiqueProv_EHDAA");
						 var map = window.cartovista.getMap(C.MAP.ID);
             var layerConfigs = [ThematiqueProv_Reseau, ThematiqueProv_EHDAA];
             _.forEach(layerConfigs, function(layerConfig){
                 var layer = map.getLayer(layerConfig.LAYER_ID);
                 _.forEach(layerConfig.JOIN, function(joinConfig){joinDataTable(layer, layerConfig, joinConfig)});
             });
             window.cartovista.dispatchEvent(new DBxEvent("ServerDataInitialized"));
            });
    };

    export function createLayers() {
        var map = window.cartovista.getMap(C.MAP.ID);
        _.forEach(C.LAYERS, function(layerConfig) {
            var layer = createLayer(layerConfig),
                index = typeof layerConfig.INDEX != "undefined" ? layerConfig.INDEX : map.layers.length;
            map.addLayerAt(layer, index);
            window.cartovista.dispatchEvent(new DBxEvent(layerConfig.LAYER_ID + "_layerCreated", {"layer": layer}));
        });
    };

    export function createThemeSetsElements() {
        var map = window.cartovista.getMap(C.MAP.ID),
            themeSetsElements = _.map(C.THEMESETS_ELEMENTS, createThemeSetElement);
        map.addThemeSetElement(themeSetsElements);
    };

    export function initZoomLayeringLayers() {
        var zlLayersConfigs = _.filter(C.LAYERS, "ZOOM_LAYERING");
        _.forEach(zlLayersConfigs, function(layerConfig) {
            new ZoomLayeringServer(layerConfig);
        });
    };